export const SORT_OPTIONS = [
  { value: 'created_date_desc', label: 'Created date (newest)' },
  { value: 'created_date_asc', label: 'Created date (oldest)' },
  { value: 'name_asc', label: 'Name (A-Z)' },
  { value: 'name_desc', label: 'Name (Z-A)' },
]

export const DEFAULT_SORT = 'created_date_desc'

/**
 * Maps a sort option to the list APIs' `sortingColumn` / `asc` params.
 * The name column differs per entity (`name` for courses, `collectionName`
 * for collections).
 */
export const toSortParams = (sort, nameColumn = 'name') => {
  if (sort.startsWith('name')) {
    return { sortingColumn: nameColumn, asc: sort === 'name_asc' }
  }
  return { sortingColumn: 'createdAt', asc: sort === 'created_date_asc' }
}

export const formatShortDate = value =>
  value
    ? new Date(value).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      })
    : ''
